export default class FormResStatus {
    /**
     * Истина, если форма уже отправлялась хотя бы раз
     */
    alreadySent = false

    private _pending = false

    /**
     * Статус отправки формы. Истина - форма отправлена и ожидается ответ от сервера
     */
    set pending(val: boolean) {
        this.alreadySent = this._pending === true && val === false ? true : (this.alreadySent ? true : false);
        this._pending = val;
    }
    get pending() {
        return this._pending
    }

    /**
     * Истина, если возникла ошибка во время отправки формы или во время обработки данных на сервера. По умолчанию ложь.
     */
    error = false

    /**
     * Истина, если форма была успешна отправлена. По умолчанию истина.
     */
    valid = true

    /**
     * Массив сообщений об успешном завершении запроса на сервер. Генерируется сервером.
     */
    success: string[] = []

    /**
     * Массив ошибок возникших во время обработки данных на сервере или во время отправки. В большинстве случаев генерируется сервером.
     */
    errorList: ErrorResObj[] = []

    /**
     * Сбросить состояние на дефолтное
     */
    reset() {
        if (this.error && !this.valid) {
            this.error = false
            this.valid = true
            this.errorList = new Array()
        }
    }

    /**
     * Установить состояние Error
     * @param errorList  Массив ошибок возникших во время обработки данных на сервере или во время отправки.
     */
    setError(errorList: ErrorResObj[]) {
        this.error = true;
        this.valid = false;
        this.errorList = errorList
    }

    /**
     * Вернуть описание ошибки для конкретного поля формы
     * @param name 
     */
    getError(name: string) {
        let errObj = this.errorList.find((errObj) => errObj.target === name)
        return errObj ? errObj.msg : undefined
    }
    pushError(error: ErrorResObj) {
        this.errorList.push(error)
    }
}

export interface ErrorResObj {
    /**
     * Имя поля формы в котором произошла ошибка
     */
    target: string

    /**
     * Описание ошибки
     */
    msg: string
}